import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250410113957/app/[lng]/(home)/advertise_page/website_ad/(advertisement_switcher)/WebsiteModel.tsx");
